import React from "react";

const RequiredStar = () => {
  return (
    <span 
      style={{ 
        color: "#ef4444", // Red color
        marginLeft: "4px",
        fontWeight: "bold",
        fontSize: "1.2em",
        lineHeight: 0,
        verticalAlign: "middle"
      }} 
      title="Required field"
    >
      *
    </span>
  );
};

export default RequiredStar;